import { CreateWaitlistDto, GetWaitlistEntriesDto, WaitlistEntryDto } from '@sportspredict/shared';
import api from './base-api';

const waitlistApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getWaitlists: builder.query<WaitlistEntryDto[], GetWaitlistEntriesDto>({
			query: (params) => ({ url: 'waitlists', params }),
			providesTags: ['Waitlist'],
		}),
		createWaitlist: builder.mutation<WaitlistEntryDto, CreateWaitlistDto>({
			query: (body) => ({ url: 'waitlists', method: 'POST', body }),
			invalidatesTags: ['Waitlist'],
		}),
	}),
	overrideExisting: false,
});

export const { useGetWaitlistsQuery, useLazyGetWaitlistsQuery, useCreateWaitlistMutation } =
	waitlistApi;
